<template lang="pug">
  .ResumenGeneral
    v-card.elevation-5
      v-card-text
        .asu-title Resumen de censos
        YearSelectorPanel
        v-list
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.mini-icon
                  i.material-icons check
                span.ap-Refuge
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalCensados || '-'}}
                span  Albergues* Censados
          v-list-tile(v-if="refugiosYear === refugioDefaultYear")
            v-list-tile-avatar
              span.icon-circle
                span.mini-icon
                  i.material-icons close
                span.ap-Refuge
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalNoCensados || '-'}}
                span  Albergues* no Censados
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-refugio-familias
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.cantidadFamilias || '-'}}
                span  Familias censadas
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-refugio-familias
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalPersonas || '-'}}
                span  Personas censadas
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-pareja
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalNinos || '-'}}
                span  Niños/as (0 a 14 años)
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-tercera-edad
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalAdultosMayores || '-'}}
                span  Adultos mayores (mayores a 65 años)
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-pregnant
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalEmbarazadas || '-'}}
                span  Embarazadas
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-discapacidad
            v-list-tile-content
              v-list-tile-title
                span.total {{summary.totalDiscapacitados || '-'}}
                span  Personas con discapacidad
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-acceso-bano
            v-list-tile-content
              v-list-tile-title
                span.total {{totalBanos || '-'}}
                span  Baños
          v-list-tile
            v-list-tile-avatar
              span.icon-circle
                span.ap-acceso-ducha
            v-list-tile-content
              v-list-tile-title
                span.total {{totalDuchas || '-'}}
                span  Duchas
        div.fuentes
          div(v-html="fuenteRefugioCensoByYear")
          div *Centro Habitacional Transitorio

    v-card.elevation-5.grafico
      v-card-text
        .asu-title Avance de cotas en el 2018
        v-chart(:options="echartOptions")
        .chart-legend
            .legend-text.fuentes
              div * Fuente: Promedio mensual del nivel del río para Asunción, 2018 (Dirección de meteorología e hidrología de la DINAC)
              div ** Fuente: Cálculo basado en áreas de inundación de la Municipalidad de Asunción y ubicación de viviendas del Censo Nacional de Población y Vivienda, 2012 (Dirección General de Estadísticas, Encuestas y Censos).

        v-list(dense)
          v-list-group
            template(v-slot:activator)
              v-list-tile
                v-list-tile-avatar
                  span.icon-circle
                    span.ap-institucion-afectada
                v-list-tile-content
                  v-list-tile-title Instituciones Afectadas en Cota {{ currentCota }}
            v-list-tile
              v-list-tile-content
                v-list-tile-title
                  span.total {{summary.institucionesAfectadas['Instituciones Educativas'] || '-'}}
                  span  Instituciones Educativas
            v-list-tile
              v-list-tile-content
                v-list-tile-title
                  span.total {{summary.institucionesAfectadas['Instituciones de Salud'] || '-'}}
                  span  Instituciones de Salud
            v-list-tile
              v-list-tile-content
                v-list-tile-title
                  span.total {{summary.institucionesAfectadas['Instituciones Religiosas'] || '-'}}
                  span  Instituciones Religiosas
            v-list-tile
              v-list-tile-content
                v-list-tile-title
                  span.total {{summary.institucionesAfectadas.centrosMunicipales || '-'}}
                  span  Centros Municipales
            v-list-tile
              v-list-tile-content
                v-list-tile-title
                  span.total {{summary.institucionesAfectadas['Comisarias'] || '-'}}
                  span  Comisarias

    .glosario
      span.asu-title Glosario de términos de Gestión de Riesgos
      DownloadButton.download-glosario(:href="glosarioLink")
    .glosario
      span.asu-title Georeferencia de todos los Albergues
      DownloadButton.download-glosario(:href="refugiosGeoJsonLink")
    .glosario
      span.asu-title Georeferencia de todas las Instituciones
      DownloadButton.download-glosario(:href="institucionesGeoJsonLink")
</template>

<script>
import 'echarts/lib/component/legend'
import { hasValue, clone, getData } from '@/utils/object.js'
import { mapGetters } from 'vuex'
import { monthMapper, refugioDefaultYear } from '@/constants.js'
import theme from '@/theme.js'

const initialSummary = {
  totalCensados: 0,
  totalNoCensados: 0,
  totalNoClasificados: 0,
  cantidadFamilias: 0,
  totalNinos: 0,
  totalJovenes: 0,
  totalAdultosMayores: 0,
  totalDiscapacitados: 0,
  totalEmbarazadas: 0,
  totalPersonas: 0,
  institucionesAfectadas: {
    viviendas: 0,
    escuelas: 0,
    hospitales: 0,
    iglesias: 0,
    centrosMunicipales: 0
  }
}

const echartOptions = {
  color: [ theme.defaultHeaderColor, theme.pie.primary ],
  grid: {
    width: '76%',
    height: '60%',
    left: '11%',
    top: '5%'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  toolbox: {
    feature: {
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ['line', 'bar'] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  legend: {
    data: ['Nivel de cotas', 'Cantidad de Viviendas']
  },
  xAxis: [
    {
      type: 'category',
      data: Object.keys(monthMapper)
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: 'Cotas *',
      nameLocation: 'center',
      nameTextStyle: {
        padding: [0, 0, 20, 0]
      },
      min: 57,
      max: 63,
      interval: 1,
      axisLabel: {
        formatter: function (value) {
          return value === 57 ? '' : value
        }
      }
    },
    {
      type: 'value',
      name: 'Viviendas Afectadas **',
      nameLocation: 'center',
      nameTextStyle: {
        padding: [30, 0, 0, 0]
      },
      min: 0,
      max: 4800,
      interval: 800
    }
  ],
  series: [
    {
      name: 'Nivel de cotas',
      type: 'line',
      yAxisIndex: 0,
      data: [58, 58, 58, 58, 58, 59, 60, 61, 61, 61, 63, 63]
    },
    {
      name: 'Cantidad de viviendas',
      type: 'bar',
      yAxisIndex: 1,
      data: [100, 130, 50, 120, 200, 400, 230, 800, 920, 1090, 1250, 1300]
    }
  ]
}

export default {
  components: {
    YearSelectorPanel: _ => import('@/components/map/solucion-a-corto-plazo/panel/YearSelectorPanel')
  },
  mounted () {
    this.echartOptions = clone(echartOptions)
    this.getSummary()
    this.loadGraficoData()
  },
  data: () => ({
    summary: clone(initialSummary),
    fuenteRefugioCensoByYear: null,
    echartOptions: null,
    refugioDefaultYear,
    glosarioLink: 'https://drive.google.com/open?id=0B3z2Z2-ijeyEa3dISWpyd0xaWkNGcHRNYmZkbHpnMy1QWXM4',
    refugiosGeoJsonLink: 'https://drive.google.com/open?id=1rJG1BJVLpKN6La_U9PBZ7C2CUd8QTOyT',
    institucionesGeoJsonLink: 'https://drive.google.com/open?id=1ccJLodIjsDObQ3z54Szol38rn-lbK7XO'
  }),
  methods: {
    getSummary () {
      if (hasValue(this.refugios) && this.refugios.features && this.refugios.features.length) {
        const censo = this.censoByCurrentYear
        this.resetSummary()
        const self = this
        this.refugios.features.forEach(({ properties }) => {
          let censoByRefugio = censo[properties.nro]
          let hasCenso = hasValue(censoByRefugio)
          if (hasCenso) {
            self.summary.cantidadFamilias += censoByRefugio.familias
            self.summary.totalNinos += getData(censoByRefugio['niños']).total
            self.summary.totalJovenes += getData(censoByRefugio.jovenes).total
            self.summary.totalAdultos += getData(censoByRefugio.adultos).total
            self.summary.totalAdultosMayores += getData(censoByRefugio.adultosMayores).total
            self.summary.totalDiscapacitados += censoByRefugio.discapacidad
            self.summary.totalEmbarazadas += censoByRefugio.embarazo
            self.summary.totalPersonas += getData(censoByRefugio.personas).total || 0
            self.summary.totalCensados += 1
          } else if (this.refugiosYear === this.refugioDefaultYear && properties.estado === 'Activo') {
            self.summary.totalNoCensados += 1
          } else {
            self.summary.totalNoClasificados += 1
          }
        })
        this.getAffectedInstitutions()
      }
    },
    getAffectedInstitutions () {
      this.summary.institucionesAfectadas = clone(this.affectedInstitutions)
    },
    resetSummary () {
      this.summary = clone(initialSummary)
    },
    loadGraficoData () {
      if (this.grafico) {
        this.echartOptions.series = this.echartOptions.series.map(item => {
          item.data = this.grafico[item.name]
          return item
        })
      }
    }
  },
  computed: {
    ...mapGetters([ 'refugios', 'refugiosYear', 'currentCota', 'affectedInstitutions', 'censoByCurrentYear', 'grafico', 'getFuenteRefugioCenso', 'totalBanos', 'totalDuchas' ])
  },
  watch: {
    refugios () {
      this.getSummary()
    },
    refugiosYear () {
      this.getSummary()
    },
    censoByCurrentYear () {
      this.getSummary()
    },
    affectedInstitutions () {
      this.getAffectedInstitutions()
    },
    grafico () {
      this.loadGraficoData()
    },
    getFuenteRefugioCenso (promise) {
      promise.then(fuente => { this.fuenteRefugioCensoByYear = fuente })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

$icon-circle-size = $f30px
$icon-circle-mini-size = $f18px

.ap-refugio-familias,
.ap-kit-materiales
  font-size: $f20px
.ap-comunidad-indigena
  font-size: $f25px

.ResumenGeneral
  width: 100%
  .echarts
    width: 100%

.asu-title
  font-size: $f20px
  font-weight: bold
  color: $color_0
  margin: 0 0 $f10px 0

.v-card.grafico
  margin-top: $f15px

.v-list >>> .v-list__tile
  padding: 0

.ap-mas
  font-size: $f50px
  color: $color_0
.total
  font-size: $f20px
  font-weight: bold

.icon-circle
  background-color: $color_0
  border-radius: 50%
  color: white
  height: $icon-circle-size
  width: $icon-circle-size
  position: relative
  display: flex
  justify-content: center
  align-items: center
  .mini-icon
    background-color: $color_0
    border: $f2px solid white
    border-radius: 50%
    position: absolute
    top: - $f5px
    right: - $f8px
    height: $icon-circle-mini-size
    width: $icon-circle-mini-size
    .material-icons
      font-size: $f15px
      width: $f15px
      min-width: $f15px
      height: $f15px
      vertical-align: top

.fuentes
  font-size: $f12px
  font-style: italic
  line-height: 1.5
  color: $gray_color

.chart-legend
  position: relative
  .legend-text
    position: absolute
    width: $f420px
    top: - $f100px
    left: $f10px
    right: $f10px

.glosario
  display: flex
  align-items: center
  justify-content: space-between
  margin-top: $f20px
  padding: 0 $f20px
  .asu-title
    margin: 0
</style>
